'use strict';

exports['default'] = {
  name: 'image-card',
  type: 'text',
  render: function render() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-text-renderer/dist/commonjs/mobiledoc-text-renderer/cards/image.js
// module id = 540
// module chunks = 0